// export const GRAPHQL_DEV_CLIENT = "http://auth-dev.ap-south-1.elasticbeanstalk.com/graphql"
// export const API_URL = "http://auth-dev.ap-south-1.elasticbeanstalk.com"

// export const API_URL = "https://api-staging.stylori.com"
// export const GRAPHQL_DEV_CLIENT = "https://api-staging.stylori.com/graphql"
 export const GRAPHQL_DEV_CLIENT = "http://192.168.207.250:7001/graphql"
// export const API_URL = "http://128.199.83.45:7001"

//export const API_URL = "http://216.48.183.194:4000/api"
//  export const API_URL = "http://localhost:4000/api"
  export const API_URL = "https://api.mookambikamarket.in/api"
// export const API_URL = "http://192.168.156.250:4000/api"'69322','69323','69328','69336','69324','69327','69293','69326',